module.exports = __webpack_public_path__ + "img/zc-09.cfb9a254.svg";